import {Tooltip} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React from "react";
import Box from "@mui/material/Box";
import moment from "moment";

export const VerifiedEmailIcon = (props) => {
    const {person, positionTop = "3px"} = props;

    if (person?.primary_job_email === '') {
        return '';
    }

    return (
        <Box component="span" sx={{
            marginLeft: '8px',
            position: 'relative',
            top: positionTop,
            cursor: 'pointer'
        }}>
            <Tooltip
                title={person?.email_verified_at ? `Email verified on ${moment(person?.email_verified_at).format('DD/MM//YYYY')}` : 'Email not verified'}>
                <CheckCircleOutlineIcon
                    fontSize='small'
                    color={person?.email_verified_at ? 'success' : 'disabled'}
                />
            </Tooltip>
        </Box>
    );
}